import { ILivePoll } from 'src/models/livepoll.interface';

export const hasNextQuestion = (livePoll: ILivePoll, questionId: string) => {
  const questions = livePoll.questions!;
  const index = questions.findIndex(q => q.id === questionId);
  return questions.slice(index).length > 1;
};
